module.exports = __webpack_public_path__ + "img/麦冬.63742339.jpg";